import { sellerConstants } from '../../_constants/seller.constants';
import { sellerImageService } from '../../_services/';

export const removeSellerImageAction = {
    removeSellerImage
};

function removeSellerImage(data) {

    return dispatch => {
        dispatch(request());
        sellerImageService.removeSellerImage(data)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_REMOVE_SELLER_IMAGE } }
    function success(data) { return { type: sellerConstants.REMOVE_SELLER_IMAGE_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.REMOVE_SELLER_IMAGE_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/removeSellerImage.actions.js